<template>
    <div>
        <v-card :elevation="0" class="v-sheet theme--light br-0">
            <v-card-title>
                <v-row class="col-md-12">
                    <v-col cols="12" sm="12" md="6">
                        Administración de Puestos
                    </v-col>
                    <v-col cols="12" sm="12" md="6">
                        <v-btn
                            color=""
                            dark
                            class="mb-2 float-right bg-light-blue"
                            
                            @click="modalNueva"
                        >
                            Crear nuevo
                        </v-btn>
                    </v-col> 
            
                </v-row>
                <v-row class="col-md-12 m-0 p-0">
                    <v-divider></v-divider>
                </v-row>
            </v-card-title>
                        
            <v-card-text>
                <v-data-table
                        :headers="headers"
                        :items="puestos"
                        item-key="Id"
                        class="elevation-0"
                        :loading="tableLoading"
                        no-data-text="No hay datos para mostrar"
                    
                        :items-per-page="10"
                        dense
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon: 'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            'items-per-page-text':'Registros por página',
                            pageText: '{0}-{1} de {2}' 
                        }"
                    >
                    <template v-slot:item="{ item }" >
                        <tr v-if="item.estadosId === 1">
                            <td>{{ item.id }}</td>
                            <td>{{ item.nombrePuesto }}</td>
                            <td>
                                <v-chip
                                        class="ma-2"
                                        :color="item.estadosId === 1 ? 'teal' : 'orange' "
                                        text-color="white"
                                        small
                                    >
                                        {{item.estado}}
                                </v-chip>
                            </td>
                            <td>
                                <v-btn class="ma-2" small tile outlined color="indigo" @click="obtenerDatosItem(item.id)">
                                    <v-icon left>mdi-pencil</v-icon> Actualizar
                                </v-btn>
                            </td>
                        </tr>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>




    <!-- Inicio:: Dialog para mostrar los datos de la puesto-->
    <v-dialog
        v-model="dialog"
        max-width="600px" 
        persistent 
        transition="dialog-bottom-transition"
        
    >
        
        <v-card scrollable>
            <v-card-title>
                {{modalTitle}}
                
                <v-spacer></v-spacer>
                <v-btn
                    icon
                    :disabled="btnRegistroLoading"
                    @click="dialog = false; resetForm()"
                    class="float-right"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-form
                ref="form"
                v-on:submit.prevent="registrarItem"
                v-model="validForm"
                >
                <v-card-text>
                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                            <v-text-field
                                outlined
                                autocomplete="off"
                                class="required"
                                maxlength="50"
                                dense
                                v-model="datosPuesto.nombrePuesto"
                                label="Nombre del puesto"
                                :rules="[
                                    required('Nombre del puesto'),
                                    alphaRule('Puesto'),
                                    minLength('Puesto', 3)
                                ]"
                            ></v-text-field>
                        </v-col>
                    </v-row>

                    <v-row>
                        <v-col  md="12" sm="12" class="pt-1 pb-1">
                             <label class="grey--text body-2">Estado</label>
                             <template>
                                <v-switch
                                    v-model="switchItemEstado"
                                    inset
                                    :label="switchItemEstado ? 'Activo' : 'Inactivo'"
                                    >
                                </v-switch>
                             </template>
                        </v-col>
                    </v-row>

                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                            <v-btn
                                color="grey lighten-5"
                                elevation="0"
                                class="mb-2 float-right grey lighten-5"
                                @click="dialog = false; resetForm()"
                                :disabled="btnRegistroLoading"
                            >
                                Cancelar
                            </v-btn>
                            <!--:disabled="!validDocForm" type="submit"-->
                            <v-btn
                                color="primary"
                                class="mb-2 float-right"
                                type="submit"
                                :elevation="0" 
                                :disabled="!validForm" 
                                :loading="btnRegistroLoading"                         
                            >
                                {{btnRegistroText}}
                            </v-btn>
                </v-card-actions>
            </v-form>
        </v-card>
    </v-dialog>


    <!-- Fin:: Dialog para mostrar los datos de la puesto-->

    <!--Dialog loader -->
    <dialog-loader
        :dialogVisible="dialogLoaderVisible"
        :text="dialogLoaderText"
    ></dialog-loader>
    <!---->

    <!--Inicio:: Snack alert-->
    <SnackAlert ref="snackalert"></SnackAlert>
    <!-- Fin:: Snack alert-->
    </div>
</template>
<script>
import validations from "@/core/untils/validations.js";

import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import { OBTENER_PUESTOS, OBTENER_PUESTO, REGISTRAR_PUESTO, ACTUALIZAR_PUESTO } from "@/core/services/store/puesto.module";

import SnackAlert from '@/view/content/SnackAlert.vue';
import DialogLoader from "@/view/content/DialogLoader";

export default {
    name: "AdminPuestos",
    components: {
        SnackAlert,
        DialogLoader
    },
    data() {
        return {
            validForm:false,
            itemName : "Puestos",
            dialog: false,
            modalTitle: 'Registrar Puesto',
            btnRegistroLoading: false,
            dialogLoaderVisible: false,
            dialogLoaderText: 'Obteniendo informacion....',
            btnRegistroText: 'Registrar puesto',
            accion: 1,
            puestos: [],
            switchItemEstado: true,
            datosPuesto: {
                id: 0,
                nombrePuesto: '',
                estadosId: 1,
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23'
            },
            
            tableLoading: false,
            ...validations
        } 
    }, 
    methods: {
        modalNueva(){
            this.accion =1;
            this.modalTitle='Registrar Puesto';
            this.btnRegistroText='Registrar Puesto';
            this.switchItemEstado=true;
            this.dialog=true;
        },

        resetForm(){
           // this.$refs.form.reset();
           
            this.datosPuesto ={
                id: 0,
                nombrePuesto: '',
                estadosId: 1,
                usuarioCreacion: 'admin',
                fechaCreacion: '2021-07-23'
            },
            this.switchItemEstado = true;
            //console.log(this.switchItemEstado)
        },

        //!Obtener las etnias para la tabla
        obtnenerItems(){
            this.tableLoading = true;
            this.puestos=[];
            
            this.$store
                .dispatch(OBTENER_PUESTOS)
                .then(() => {
                    this.puestos = this.$store.state.puesto.puestos;
                    this.tableLoading =false;
                //console.log(this.etnias)
                })
                .catch(() => {
                    this.tableLoading = false;
                });

        },

        obtenerDatosItem(Id){
            this.dialogLoaderVisible=true;
            this.datosPuesto.id = Id;
            this.accion=2;
            this.modalTitle='Actualizar puesto';
            this.btnRegistroText='Actualizar puesto';

            this.$store
                .dispatch(OBTENER_PUESTO, Id)
                .then(res => {
                    if(res.status===200){
                        this.datosPuesto = this.$store.state.puesto.puesto;
                        this.datosPuesto.estadosId === 1 ? this.switchItemEstado = true : this.switchItemEstado = false;
                        this.dialog = true;
                    } else {
                        let message = 'Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema.';
                        if(res.message){
                            message = res.message;
                        }
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', message);
                    }

                    this.dialogLoaderVisible = false;
                })
                .catch(error => {
                    this.dialogLoaderVisible = false;
                    this.$refs.snackalert.SnackbarShow('warning', 'Alerta', `Ha ocurrido un error, por favor, ponte en contacto con un administrador del sistema. REF: ${error}`);
                });
        },

        registrarItem(){
            //console.log(this.accion)
            
            this.btnRegistroLoading=true;

            this.switchItemEstado ? this.datosPuesto.estadosId = 1 : this.datosPuesto.estadosId = 2;

            if(this.accion===1){
                this.datosPuesto.id = 0;
                this.$store
                    .dispatch(REGISTRAR_PUESTO, this.datosPuesto)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

                        

            } else {
                this.$store
                    .dispatch(ACTUALIZAR_PUESTO, this.datosPuesto)
                    .then(res => {
                        //console.log(res)
                        if(res.status===200){
                            this.obtnenerItems();
                            this.dialog=false;
                            this.$refs.snackalert.SnackbarShow('success', 'Mensaje', res.message);
                            this.resetForm();
                            //this.switchItemEstado = true;
                        } else {
                            this.$refs.snackalert.SnackbarShow('warning', 'Alerta', res.message);
                        }
                        this.btnRegistroLoading=false;
                    })
                    .catch(error => {
                        //console.log(error)
                        this.$refs.snackalert.SnackbarShow('warning', 'Alerta', error);
                        this.btnRegistroLoading=false;
                    });

            }
        }
    },
    mounted() {
        //Definir el nombre en el breadcrumb
        this.$store.dispatch(SET_BREADCRUMB, [
            { title: "Administración", route: "/dashboard" },
            { title: "Catalogos" },
            { title: "Puestos" }
        ]);
    },

    created(){
        this.obtnenerItems();
    },

    
    computed: {
        headers() {
            return [
                {
                    text: "Id",
                    align: "start",
                    sortable: true,
                    value: "id"
                },
                {
                    text: "Nombre del puesto",
                    value: "nombrePuesto"
                },
                {
                    text: "Estado",
                    value: "estadosId"
                },
                {
                    text: "Acciones",
                    value: "Acciones"
                }
            ]
        }
    }

    
}
</script>
<style lang="">
    
</style>